import React, { FC } from 'react';
import styled from 'styled-components';

const DetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 15px;
`;

const RowLabel = styled.div``;

const RowValue = styled.div`
  color: #707c83;
  margin-left: auto;
`;

type SectionData = {
  col1: any;
  col2: any;
}

interface AppDetailsSectionProps {
  data: SectionData[];
}

const AppDetailsSection: FC<AppDetailsSectionProps> = (props) => {
  const { data } = props;

  return (
    <React.Fragment>
      {data.map(({ col1, col2 }, index) => (
        <DetailsRow key={index}>
          <RowLabel>{col1}</RowLabel>
          <RowValue>{col2}</RowValue>
        </DetailsRow>
      ))}
    </React.Fragment>
  );
};

export default AppDetailsSection;
